<div kendoWindowContainer></div>
<div kendoDialogContainer></div>

<router-outlet></router-outlet>
